import { CodedProperty, NamedProperty } from "sprint-common-web";

import { GetSingleAncillaryResponse } from "../../../../common/api/catalogue-api/ancillary/GetSingleAncillaryResponse";
import { AncillaryContentSubtype, isAncillaryContentSubtype } from "../../../../common/types/AncillaryContentType";
import { ContentSubtype } from "../../../../common/types/ContentSubtype";

export interface AncillaryCatalogueEntry {
    id: string;
    title: string;
    contentType: AncillaryContentSubtype;
    buzzId?: string;
    orphaned: boolean;
    version: AncillaryVersionCatalogueEntry;
}

export interface AncillaryVersionCatalogueEntry {
    id: string;
    buzzId?: string;
    type: NamedProperty;
    distributor?: NamedProperty;
    airlines?: CodedProperty[];
}

export const mapToAncillaryCatalogueEntry = (response: GetSingleAncillaryResponse): AncillaryCatalogueEntry => {
    if (!isAncillaryContentSubtype(response.subtype)) {
        throw new Error(`Type ${ContentSubtype[response.subtype]} is not ancillary content type.`);
    }

    return {
        ...response,
        contentType: response.subtype
    };
};
